module.exports = __webpack_public_path__ + "static/media/SHIVAM JI_page-0001.6d21d021.jpg";